import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from "@angular/common";

@Injectable()
export class AuthRedirectService {

    constructor(
        @Inject(DOCUMENT) private readonly document: Document,
    ) {
    }

    /**
     * Redirects to login page.
     */
    public redirectToLogin(): void {
        const wuiUrl: string = sessionStorage.getItem('$wui_url');
        const baseUrl: string = sessionStorage.getItem('$base_url');
        const instanceUrl: string = sessionStorage.getItem('$instance_url');

        // We do not use Router here because it's complicated with non-WUI apps.
        if (wuiUrl && !baseUrl) {
            console.warn('Redirecting to login page for WUI app...');
            this.document.defaultView.open(`${wuiUrl}${wuiUrl.endsWith('/') ? '' : '/'}login`, '_self');
        } else if (baseUrl && baseUrl.includes('wui_stock')){
            console.warn('Redirecting to login page for OSMAN app...');
            this.document.defaultView.open(`${instanceUrl}wui_stock/v2/logout`, '_self');
        } else if (baseUrl && baseUrl.includes('wui_watabi')){
            console.warn('Redirecting to login page for WATABI app...');
            this.document.defaultView.open(`${instanceUrl}wui_watabi/logout`, '_self');
        }
    }
}
